@let selectedRequestsAddresses = $selectedRequestsAddresses();
@let actualDeliveryAddressValue = selectedRequestsAddresses[0];
@let canLogistAddDevices = permissionService.canLogistAddDevices$ | async;

<style>
  :host {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
</style>

<div class="x-card x-card_size_m x-white card-shadow grow flex! flex-col">
  @if (!canLogistAddDevices) {
    <div class="x-input-label">
      {{ 'group_actions.actual_address.actual_address' | translate }}
    </div>
    @if (selectedRequestsAddresses.length) {
      <div class="text-center">
        <div>
          {{ actualDeliveryAddressValue }}
        </div>
        @if ($isDeliveryAddressDifferentFromActual()) {
          <div class="text-sm mt-1">
            {{ 'group_actions.actual_address.differs' | translate }}
          </div>
        }
      </div>
    } @else {
      <div class="text-center x-text-danger text-sm font-medium">
        {{ 'group_actions.actual_address.validation_required' | translate }}
      </div>
    }
    <div class="text-orange-400 text-sm mt-1 text-center font-medium">
      {{ 'group_actions.actual_address.no_rights_to_change' | translate }}
    </div>
  } @else {
    <div class="x-input-label">
      {{ 'group_actions.actual_address.actual_address' | translate }}
    </div>
    <form [formGroup]="formGroup">
      <x-form-picker
        [stringifyFn]="stringifyFn"
        [formControlName]="FormFields.ActualDeliveryAddress"
        [withCleaner]="true"
        [strict]="false"
        xAttachActualDeliveryAddresses
      ></x-form-picker>
    </form>

    @if (actualDeliveryAddressToSet.value) {
      @if (!isEnteredActualDeliveryAddressVerified) {
        <div class="x-text-danger text-sm font-medium mt-1">
          {{ 'group_actions.actual_address.validation_required' | translate }}
        </div>
        <a
          href="https://maps.yandex.ru/?text={{
            actualDeliveryAddressToSet.value
          }}&l=sat%2Cskl"
          rel="noreferrer"
          target="_blank"
          tuiButton
          type="button"
          size="m"
          appearance="outline-grayscale"
          tuiAppearanceMode="checked"
          iconEnd="@tui.external-link"
          class="w-full mt-7 font-normal! back outline-with-green-borders-btn"
          (click)="onCheckAddressButtonClick()"
        >
          <span class="text-sm">{{
            'group_actions.actual_address.check_on_map' | translate
          }}</span></a
        >
      } @else {
        <div class="x-text-green text-sm font-medium mt-1">
          {{ 'group_actions.actual_address.checked' | translate }}
        </div>
      }
    }

    @if (isEnteredActualDeliveryAddressVerified) {
      <button
        id="verifyButton"
        tuiButton
        type="button"
        size="m"
        class="w-full mt-auto"
        (click)="setActualDeliveryAddress()"
      >
        <span class="py-2 text-sm">{{
          'group_actions.actual_address.confirm' | translate
        }}</span>
      </button>
    }
  }
</div>
